import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Datepicker from 'components/Datepicker'
import SearchBarWithSelect from 'components/SearchBarWithSelect'
import Select from 'components/Select'

import { SEARCH_BAR_ORDERS_OPTIONS } from 'utils/resources'
import { ReactComponent as IconFilter } from 'assets/icons/IconFilter.svg'
import {
  getOrdersApiParamsConfig,
  getOrdersSearchFilters,
} from 'store/Orders/selector'

const DesktopFilters = ({
  onChange,
  startDate,
  endDate,
  handleSetFilter,
  statesOptions,
  alphabeticalSortedRevenueCenters,
  handleSearchAndSelect,
  onClickFilterBtn,
}) => {
  const ordersApiParamsConfig = useSelector(getOrdersApiParamsConfig)
  const { searchQuery, selectedSearchOptionUuid } = useSelector(
    getOrdersSearchFilters
  )

  const { state, standUuid } = ordersApiParamsConfig

  return (
    <div className="orders-filters">
      <div className="orders-filters__select-wrapper">
        <Datepicker
          onChange={onChange}
          startDate={startDate}
          endDate={endDate}
          maxDate={new Date()}
          placeholder={'Date/Time Range'}
          dateFormat={'MM/dd/yy'}
          selectsRange={true}
          isOpenButton
        />
        <Select
          id="status"
          handleChange={handleSetFilter('state')}
          nameClass="-small"
          label="All Status"
          options={statesOptions}
          defaultValue={state ?? ''}
        />
        <Select
          id="revenueCenter"
          handleChange={handleSetFilter('standUuid')}
          nameClass="-medium"
          label="All Revenue Centers"
          options={alphabeticalSortedRevenueCenters}
          defaultValue={standUuid ?? ''}
        />
      </div>
      <SearchBarWithSelect
        handleSearch={handleSearchAndSelect}
        options={SEARCH_BAR_ORDERS_OPTIONS}
        selectedOptionUuid={selectedSearchOptionUuid}
        defaultInputValue={searchQuery}
      />
      <button className="orders-filters__filter-btn" onClick={onClickFilterBtn}>
        <IconFilter />
      </button>
    </div>
  )
}

DesktopFilters.propTypes = {
  onChange: PropTypes.func,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  handleSetFilter: PropTypes.func,
  statesOptions: PropTypes.array,
  alphabeticalSortedRevenueCenters: PropTypes.array,
  handleSearchAndSelect: PropTypes.func,
  onClickFilterBtn: PropTypes.func,
}

export default DesktopFilters
